module.exports = __webpack_public_path__ + "img/bne3.7bf9be02.jpg";